import EntityInputField from "vue-forms/components/EntityInputField";
import EntityFormField from "vue-forms/components/EntityFormField";
import service from "./CustomerService";

const CustomerInputField = {
  name: "customer-input-field",

  mixins: [EntityInputField],

  props: {
    service: {
      default: () => service
    }
  },

  methods: {
    customLabel(item) {
      return item.companyName;
    }
  }
};

export default {
  name: "customer-form-field",

  mixins: [EntityFormField],

  props: {
    component: {
      default: () => CustomerInputField
    }
  }
};
